<template>
  <div class="home">
    <ProjectList v-show="listView" @newProject="onClickNewFromList" @editProject="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <ProjectForm v-show="formView" :project="project" :ref="ref_no" @backClicked="onBackChild"/>
    <!-- <pre>{{ project }}</pre> -->
  </div>
</template>

<script>
// @ is an alias to /src
import ProjectList from '@/components/project/ProjectList.vue'
import ProjectForm from '@/components/project/ProjectForm.vue'
import { getHeader, projectUrl } from '../config'
import Axios from 'axios'

export default {
  name: 'ProjectManage',
  components: {
    ProjectList,
    ProjectForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      ref_no: null,
      project: {
        id: null,
        project_no: null,
        sale_no: null,
        project_name: null,
        type_id: null,
        schedule_date: null,
        estimated_date: null,
        start_project: null,
        end_project: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        notes: null,
        pic: null,
        branch_no: null,
        branch: null,
        status: null,
        engineers: [{
          id: null,
          engineer_id: null,
          engineer: null,
          state: null
        }],
        handovers: [{
          id: null,
          project_no: null,
          product_no: null,
          product: {
            id: null,
            product_no: null,
            product_name: null
          },
          qty: null,
          uom_id: null,
          serial_number: null,
          description: null,
          ip_address: null,
          uomList: [{
            id: null,
            name: null
          }]
        }],
        attachments: [{
          id: null,
          project_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        user_pic: {
          id: null,
          name: null
        },
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        lock: false
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.project = value
      if (this.project.status === 'finish') {
        this.project.lock = true
      }
      this.$store.dispatch('getCustomerList')
    },
    getEditSales: function (value, ref) {
      console.log(projectUrl + '/' + value)
      Axios.get(projectUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.project = response.data.data
          this.ref_no = ref
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.$store.dispatch('getCustomerList')
      this.listView = false
      this.formView = true
      this.project = {
        id: null,
        project_no: null,
        sale_no: null,
        project_name: null,
        type_id: null,
        schedule_date: null,
        estimated_date: null,
        start_project: null,
        end_project: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        notes: null,
        pic: null,
        branch_no: null,
        branch: null,
        status: null,
        engineers: [{
          id: null,
          engineer_id: null,
          engineer: null,
          state: null
        }],
        handovers: [{
          id: null,
          project_no: null,
          product_no: null,
          product: {
            id: null,
            product_no: null,
            product_name: null
          },
          qty: null,
          uom_id: null,
          serial_number: null,
          description: null,
          ip_address: null,
          uomList: [{
            id: null,
            name: null
          }]
        }],
        attachments: [{
          id: null,
          project_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        user_pic: {
          id: null,
          name: null
        },
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        lock: false
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.project = {
        id: null,
        project_no: null,
        sale_no: null,
        project_name: null,
        type_id: null,
        schedule_date: null,
        start_project: null,
        end_project: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        notes: null,
        pic: null,
        branch_no: null,
        branch: null,
        status: null,
        engineers: [{
          id: null,
          engineer_id: null,
          engineer: null,
          state: null
        }],
        handovers: [{
          id: null,
          project_no: null,
          product_no: null,
          product: {
            id: null,
            product_no: null,
            product_name: null
          },
          qty: null,
          uom_id: null,
          serial_number: null,
          description: null,
          ip_address: null,
          uomList: [{
            id: null,
            name: null
          }]
        }],
        attachments: [{
          id: null,
          project_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        user_pic: {
          id: null,
          name: null
        },
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        lock: false
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getProjectTypeList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getUserAll')
    // get query param from url
    // var form = this.$route.query.form
    var salesParam = this.$route.query.id
    if (typeof salesParam !== 'undefined') {
      this.getEditSales(salesParam)
    }
  }
}
</script>
